export default "__VITE_ASSET__7a7503d0__"